// In your dispatcher/routes.ts
import { RouteObject } from "react-router-dom";
import Landing from "./components/landing/landing";
import AssignedMeterServiceOrderView from "./components/assigned/view/AssignedMeterServiceOrderView";
import AssignedConsumerServiceOrderView from "./components/assigned/view/AssignedConsumerServiceOrderView";
import AssetServiceOrderView from "./components/pending/view/AssetServiceOrderView";
import CreateServiceOrder from "./components/create/CreateServiceOrder";
import ConsumerServiceOrderView from "./components/pending/view/ConsumerServiceOrderView";
import MeterServiceOrderView from "./components/pending/view/MeterServiceOrderView";
import CompletedServiceOrderViewPage from "./components/completed/view/CompletedServiceOrderView";
import HistoryServiceOrderViewPage from "./components/history/view/HistoryServiceOrderView";
import ServiceOrderDetail from "./components/rejected/view/rejectedServiceOrderView";
import AssetCompletedServiceOrderViewPage from "./components/completed/asset/assetCompletedServiceOrderView";
import AssetHistoryServiceOrderViewPage from "./components/history/asset/assetHistoryServiceOrderView";
import AssetPendingServiceOrderView from "./components/pending/view/AssetServiceOrderView";
import AssetAssignedServiceOrderView from "./components/assigned/view/AssignedAssetServiceOrderView";
import ServiceOrderDetails from "./components/rejected/view/rejectedServiceOrderView";

export interface DispatcherSetupRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: DispatcherSetupRoute[];
}

export const dispatcherSetupRoutes: DispatcherSetupRoute[] = [
  {
    path: "/service-orders/dispatcher",
    element: <Landing />,
  },
  // ✅ Meter Service Order Route
  {
    path: "/service-orders/dispatcher/assigned-meter-service-order/:id",
    element: <AssignedMeterServiceOrderView />,
    auth: true, // Add auth if needed
  },
  // ✅ Consumer Service Order Route
  {
    path: "/service-orders/dispatcher/assigned-consumer-service-order/:id",
    element: <AssignedConsumerServiceOrderView />,
    auth: true,
  },
  // ✅ Asset Service Order Route
  {
    path: "/service-orders/dispatcher/assigned-asset-service-order/:serviceType/:id",
    element: <AssetAssignedServiceOrderView />,
    auth: true,
  },
  {
    path: "/service-orders/wx-dashboard/create-service-order",
    element: <CreateServiceOrder />,
  },
  {
    path: "/service-orders/dispatcher/pending-meter-service-order/:id",
    element: <MeterServiceOrderView />,
    auth: true, // Add auth if needed
  },
  // ✅ Consumer Service Order Route
  {
    path: "/service-orders/dispatcher/pending-consumer-service-order/:id",
    element: <ConsumerServiceOrderView />,
    auth: true,
  },
  // ✅ Asset Service Order Route
  {
    path: "/service-orders/dispatcher/pending-asset-service-order/:serviceType/:id",
    element: <AssetPendingServiceOrderView />,
    auth: true,
  },
  {
    path: "/service-orders/dispatcher/completed-meter-service-order/:id",
    element: <CompletedServiceOrderViewPage />,
  },
  // ✅ Consumer Service Order Route
  {
    path: "/service-orders/dispatcher/completed-consumer-service-order/:id",
    element: <CompletedServiceOrderViewPage />,
  },
  // ✅ Asset Service Order Route
  {
    path: "/service-orders/dispatcher/completed-asset-service-order/:serviceType/:id",
    element: <AssetCompletedServiceOrderViewPage />,
  },
  {
    path: "/service-orders/dispatcher/completed-facility-service-order/:id",
    element: <CompletedServiceOrderViewPage />,
  },

 
 {
    path: " /service-orders/dispatcher/completed-service-order/:id",
    element: <CompletedServiceOrderViewPage />,
  },
  {
    path: "/service-orders/dispatcher/history-service-order/:id",
    element: <HistoryServiceOrderViewPage />,
  },
  
    {
    path: "/service-orders/dispatcher/rejected-service-order/:id",
    element: <ServiceOrderDetails order={{
      id: "",
      name: "",
      originalTechnician: "",
      priority: "",
      rejectedBy: "",
      rejectionReason: "",
      rejectedOn: "",
      status: "",
      reworkSO: "",
      rejectionComments: "",
      parentOrderId: ""
    }} status={"completed"} />,
    },
  {
    path: "/service-orders/dispatcher/history-asset-service-order/:serviceType/:id",
    element: <AssetHistoryServiceOrderViewPage />,
  },
  // ✅ Consumer Service Order Route
];
